(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trusted-coaches-slider"] && !Shopify.designMode) return;
  try {
    
function initTrustedSlider() {
  if (window.jQuery && jQuery.fn.slick) {
    var $slider = jQuery('.trusted-slider__wrapper');

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: window.innerWidth > 1920 ? 6 : 3,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        centerPadding: window.innerWidth > 1920 ? '0px' : '15%',
        arrows: true,
        prevArrow: jQuery('#prevBtn'),
        nextArrow: jQuery('#nextBtn'),
        dots: false,
        responsive: [
          {
            breakpoint: 1920,
            settings: {
              slidesToShow: 3,
              centerPadding: '15%'
            }
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              centerPadding: '10%'
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              centerPadding: '80px'
            }
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 1,
              centerPadding: '20px'
            }
          }
        ]
      });
    }
  } else {
    setTimeout(initTrustedSlider, 100);
  }
}

initTrustedSlider();

  } catch(e) { console.error(e); }
})();
})();
